
export const STRIPE_PAYMENT_REQUEST = "STRIPE_PAYMENT_REQUEST"
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS"
export const STRIPE_PAYMENT_FAIL = "STRIPE_PAYMENT_FAIL"